import { Card, CardContent, Typography, Link, Box } from '@mui/material'
import { getExampleCsv } from '../repository/getExampleCsv'

const styles = {
  container: {
    padding: 3
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold'
  },
  bodyText: {
    mb: 2
  },
  listItem: {
    my: 1
  },
  nestedList: {
    mt: 0.5,
    mb: 0
  },
  sectionTitle: {
    mt: 2,
    mb: 1
  },
  finalText: {
    mt: 2
  },
  link: {
    cursor: 'pointer',
    fontWeight: 'bold'
  }
}

export const NoOrders = () => {
  const handleExampleCsv = async () => {
    const csv = await getExampleCsv()

    const url = window.URL.createObjectURL(new Blob([csv]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'example.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  return (
    <Box sx={styles.container}>
      <Card>
        <CardContent>
          <Typography gutterBottom sx={styles.cardTitle}>
            This is the orders page.
          </Typography>
          <Typography variant="body2" sx={styles.bodyText}>
            This is where you will be able to access all of the orders for the
            products you sell through StackCommerce.
          </Typography>
          <Typography variant="body2" sx={styles.sectionTitle}>
            If you are selling <strong>physical goods</strong>, this is where
            you will:
          </Typography>
          <Box component="ul" sx={styles.listItem}>
            <li>
              <Typography variant="body2" component="span">
                See your workflow summary: how many orders you need to fulfill,
                and how many have been completed.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                Download the orders that you need to fulfill in a CSV format for
                use with your shipping carrier's software.
              </Typography>
              <Box component="ul" sx={styles.nestedList}>
                <li>
                  <Typography variant="body2" component="span">
                    Here is an{' '}
                    <Link
                      color="primary"
                      sx={styles.link}
                      onClick={handleExampleCsv}
                    >
                      example CSV
                    </Link>
                  </Typography>
                </li>
              </Box>
            </li>
            <li>
              <Typography variant="body2" component="span">
                Upload the shipment tracking numbers generated by your shipping
                carrier's software.
              </Typography>
            </li>
          </Box>

          <Typography variant="body2" sx={styles.sectionTitle}>
            If you are selling <strong>digital goods</strong>, this is where you
            will:
          </Typography>
          <Box component="ul" sx={styles.listItem}>
            <li>
              <Typography variant="body2" component="span">
                See how many purchases have been made for each product.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                Download a list of your customers and the licenses/serial
                numbers they have.
              </Typography>
            </li>
          </Box>

          <Typography variant="body2" sx={styles.finalText}>
            Check back here when your products go live.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
